import { stringify } from "../../util/querystring-util";
import {
  GetUserRolesRequest,
  GetUserRolesResponse,
  CreateUserRolesRequest,
  CreateUserRolesResponse,
  DeleteUserRolesRequest,
  DeleteUserRolesResponse,
} from ".";
import { restResourceRequester } from "../rest-resource-requester";

interface UserRolesRestResource {
  /**
   * GET /
   */
  getUserRoles(request: GetUserRolesRequest): Promise<GetUserRolesResponse>;

  /**
   * PUT /
   */
  createUserRoles(
    request: CreateUserRolesRequest,
  ): Promise<CreateUserRolesResponse>;

  /**
   * DELETE /
   */
  deleteUserRoles(
    request: DeleteUserRolesRequest,
  ): Promise<DeleteUserRolesResponse>;
}

const REST_RESOURCE_NAME = "/user-roles";

/**
 * GET /user-roles
 */
const getUserRoles = restResourceRequester<
  GetUserRolesRequest,
  GetUserRolesResponse
>("GET", (request) => `${REST_RESOURCE_NAME}?${stringify(request)}`);

/**
 * PUT /user-roles
 */
const createUserRoles = restResourceRequester<
  CreateUserRolesRequest,
  CreateUserRolesResponse
>(
  "PUT",
  (request) => REST_RESOURCE_NAME,
  (request) => JSON.stringify(request),
);

/**
 * DELETE /user-roles
 */
const deleteUserRoles = restResourceRequester<
  DeleteUserRolesRequest,
  DeleteUserRolesResponse
>(
  "DELETE",
  (request) => REST_RESOURCE_NAME,
  (request) => JSON.stringify(request),
);

export const UserRolesRestResource: UserRolesRestResource = {
  getUserRoles: getUserRoles,
  createUserRoles: createUserRoles,
  deleteUserRoles: deleteUserRoles,
};
